import { Alert, Tooltip } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import ReactDOM from 'react-dom'
import { $t } from '@/i18n/intl'

const globalKey = '__yt_build_info__'
const containerkey = 'checkVersion'
/** 高于 Ant Design Modal 默认 z-index(1000)，避免被登录弹层 mask 遮挡 */
const VERSION_ALERT_Z_INDEX = 2000

function compareVersions(version1: string, version2: string) {
  const v1Parts = version1.split('.').map(Number)
  const v2Parts = version2.split('.').map(Number)
  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    if (v1Parts[i] === undefined) {
      v1Parts[i] = 0
    }
    if (v2Parts[i] === undefined) {
      v2Parts[i] = 0
    }
    if (v1Parts[i] > v2Parts[i]) {
      return 1
    } else if (v1Parts[i] < v2Parts[i]) {
      return -1
    }
  }
  return 0
}

const getLocalVersionInfo = (): Partial<YtBuildInfo> => {
  const localBuildInfo = window?.[globalKey] || {}
  return localBuildInfo
}

function renderAlert() {
  const div = document.createElement('div')
  div.id = containerkey
  div.style.display = 'inline-flex'
  div.style.position = 'fixed'
  div.style.left = '50%'
  div.style.top = '-50px'
  div.style.zIndex = String(VERSION_ALERT_Z_INDEX)
  div.style.transform = 'translate(-50%, 0)'
  div.style.transition = 'top 1s'

  const existingDiv = document.getElementById(containerkey)
  if (!existingDiv) {
    document.body.appendChild(div)
    setTimeout(() => {
      div.style.top = '20px'
    }, 0)

    ReactDOM.render(
      <Alert
        message={
          <div
            onClick={() => {
              location.reload()
            }}
            style={{
              cursor: 'pointer',
              padding: '0 20px',
              color: 'green'
            }}
          >
            {$t('check_app_version.tips')}
            <Tooltip title={$t('check_app_version.refresh_btn')}>
              <ReloadOutlined />
            </Tooltip>
          </div>
        }
        banner
        onClose={() => {
          setTimeout(() => {
            unmountAlert()
          }, 200)
        }}
      />,
      div
    )
  }
}

function unmountAlert() {
  const div = document.getElementById(containerkey)
  if (div) {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }
}

export const startSSEStrategy = ({
  serverVersionInfo,
  viteModeEnv
}: {
  viteModeEnv: string
  serverVersionInfo?: {
    version: string
    name: string
  }
}) => {
  if (!serverVersionInfo || viteModeEnv === 'mock') return false
  const localBuildInfo = getLocalVersionInfo()
  if (!localBuildInfo?.version || serverVersionInfo.name !== localBuildInfo.name) {
    return false
  }

  const diffVal = compareVersions(serverVersionInfo.version, localBuildInfo.version)
  if (diffVal === 0) {
    window[globalKey].needUpgrade = false
    return false
  }
  if (diffVal > 0 || diffVal < 0) {
    window[globalKey].needUpgrade = true
    renderAlert()
    return true
  }
}
